import { useQuery } from '@apollo/client/react';
import { gql } from '@apollo/client';
import {
  type GetLimitTrackingMobileQuery,
  type GetLimitTrackingMobileQueryVariables,
} from '../generated/graphql';

const LIMIT_TRACKING_MOBILE_SLUG = 'limit-tracking-mobile';

const GET_LIMIT_TRACKING_MOBILE = gql`
  query GetLimitTrackingMobile($userId: ID!, $settingSlug: String!) {
    getUserSetting(userId: $userId, settingSlug: $settingSlug) {
      value
    }
  }
`;

/**
 * Reads the user's `limit-tracking-mobile` privacy preference.
 *
 * Returns `limitTracking: true` only when the setting resolves to "true". While
 * loading, when skipped (no user), or on error it defaults to `false` (tracking
 * allowed) — matching the setting's default and the mobile app's behavior.
 */
export function useLimitTrackingMobile(userId: string | undefined) {
  const { data, loading } = useQuery<
    GetLimitTrackingMobileQuery,
    GetLimitTrackingMobileQueryVariables
  >(GET_LIMIT_TRACKING_MOBILE, {
    variables: { userId: userId ?? '', settingSlug: LIMIT_TRACKING_MOBILE_SLUG },
    skip: !userId,
  });

  const value = data?.getUserSetting?.value ?? '';

  return {
    limitTracking: value.trim().toLowerCase() === 'true',
    loading,
  };
}
